export const environment = {
  production: true,
  logging: {
		logLevels: [
			{
				loggerName: "root",
				logLevel: "TRACE"
			},
			{
				loggerName: "Ionic.Logging",
				logLevel: "OFF"
			}
		],
    memoryAppender: {
      threshold: "TRACE",
      maxMessages: 150
    },
  }
};
